import { render, staticRenderFns } from "./report_item.vue?vue&type=template&id=32fd7bf0"
import script from "./report_item.vue?vue&type=script&lang=js"
export * from "./report_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports